var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Ajax from '@core/ajax';
import View from '@core/views';
import TCTabs from '@core/libs/TCTabs';
import TCTableBuilder from '@core/libs/TCTableBuilder';
import TCAttachmentUpload from '@core/libs/TCAttachmentUpload';
import TCImageUpload from "@core/libs/TCImageUpload";
import TCStructureNodeSelect from '@core/libs/TCStructureNodeSelect';
import Navbar from '@core/components/Navbar';
import Toast from '@core/components/Toast';
import Vue from 'vue';
import VueRouter from 'vue-router';
import Dashboard from './dashboard/Dashboard';
import Bulma from '@core/plugin/bulma';
import CoreCommon from '@core/plugin/common';
import TrackingCloud from '@core/plugin/tc';
import i18n from '@core/plugin/i18n';
import CsrfPlugin from '@core/plugin/csrf';
import { TCApi } from '../../api/frontend/ts';
import Debug from '@core/plugin/debug';
var VUE_MOUNT_TARGET_SELECTOR = '#tc-app';
/**
 * Base stuff that is 'always' needed
 */
var BaseApplication = /** @class */ (function () {
    function BaseApplication() {
        var _this = this;
        this.api = new TCApi();
        this.registeredViews = {};
        this.registeredLibs = {};
        // Dummy router so that we can nicely access query params in components (ask Janne for more)
        var router = new VueRouter({
            mode: 'history'
        });
        this.beforeVueInit();
        // Mount vue
        if (document.querySelector(VUE_MOUNT_TARGET_SELECTOR)) {
            this.vueVM = new Vue({
                router: router,
                mounted: function () { return _this.onVueMounted(); },
                updated: function () { return _this.onVueUpdated(); }
            }).$mount(VUE_MOUNT_TARGET_SELECTOR);
        }
        else {
            console.warn("Unable to mount Vue to ".concat(VUE_MOUNT_TARGET_SELECTOR, ". Vue is not enabled!"));
        }
    }
    /**  */
    BaseApplication.prototype.beforeVueInit = function () {
        Vue.use(CoreCommon);
        Vue.use(Bulma);
        Vue.use(TrackingCloud);
        Vue.use(i18n);
        Vue.use(CsrfPlugin);
        Vue.use(Debug);
        Vue.component('tc-dashboard', Dashboard);
        Vue.use(VueRouter);
    };
    BaseApplication.prototype.onVueMounted = function () {
        this.el = this.getApplicationElement();
        this.navbar = new Navbar(this);
        this.mount();
        Toast.showToasts();
    };
    BaseApplication.prototype.onVueUpdated = function () {
        if (this.currentView) {
            this.currentView.onUpdated();
        }
    };
    Object.defineProperty(BaseApplication.prototype, "view", {
        /**
         * Current view
         */
        get: function () {
            return this.currentView;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Override to change application element
     * Defaut #tc-app
     */
    BaseApplication.prototype.getApplicationElement = function () {
        return document.getElementById('tc-app') || document.body;
    };
    /**
     * Override to add app specific views
     */
    BaseApplication.prototype.getViews = function () {
        return {};
    };
    BaseApplication.prototype.getLibs = function () {
        return {};
    };
    BaseApplication.prototype.mountLibs = function (root) {
        var _this = this;
        if (!root) {
            root = this.el;
        }
        root.querySelectorAll('[data-tc-lib]').forEach(function (element) {
            var libName = element.getAttribute('data-tc-lib');
            if (libName) {
                if (libName in _this.registeredLibs) {
                    var lib = new _this.registeredLibs[libName](element);
                    lib.onMounted();
                }
                else {
                    console.error("Lib ".concat(libName, " is not registered"));
                }
            }
        });
    };
    BaseApplication.prototype.mountView = function () {
        var viewElement = this.el.querySelector('[data-tc-view]');
        if (viewElement) {
            var viewName = viewElement.getAttribute('data-tc-view');
            if (viewName) {
                if (viewName in this.registeredViews) {
                    console.info('Loading TC view', viewName);
                    return new this.registeredViews[viewName](this, viewElement);
                }
            }
            console.info('Loading TC DEFAULT view');
            return new View(this, viewElement);
        }
        console.warn('No TC view element found. Please add an element with \'data-tc-view\' attribute');
    };
    /**
     * Called automatically when the DOM is ready
     */
    BaseApplication.prototype.mount = function () {
        // Register libs
        this.registeredLibs = __assign({ TCTabs: TCTabs, TCTableBuilder: TCTableBuilder, TCStructureNodeSelect: TCStructureNodeSelect, TCAttachmentUpload: TCAttachmentUpload, TCImageUpload: TCImageUpload }, this.getLibs());
        // Register views
        this.registeredViews = __assign({}, this.getViews());
        this.mountLibs();
        this.currentView = this.mountView();
        if (this.currentView != null) {
            this.currentView.onMounted();
        }
    };
    BaseApplication.Ajax = Ajax;
    return BaseApplication;
}());
export default BaseApplication;
document.addEventListener('DOMContentLoaded', function () {
    var menuButton = document.getElementById('menu_btn');
    if (menuButton) {
        menuButton.addEventListener('click', function (e) {
            var tcNav = document.getElementById('tc-navigation');
            var tonNavTransitionEnd = function () {
                tcNav.removeEventListener('transitionend', tonNavTransitionEnd);
                window.dispatchEvent(new CustomEvent('resize'));
            };
            tcNav.addEventListener('transitionend', tonNavTransitionEnd);
            document.getElementsByTagName('BODY')[0].classList.toggle('mini-navbar');
            var d = new Date();
            d.setTime(d.getTime() + (24 * 60 * 60 * 1000));
            var expires = 'expires=' + d.toUTCString(), cvalue = document.getElementsByTagName('BODY')[0].classList.contains('mini-navbar').toString();
            document.cookie = 'mini-navbar=' + cvalue + ';' + expires + ';path=/';
        });
    }
});
